<div class="modal-header" [class.warning]="warning">
    <h5 class="modal-title">{{ title }}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="dismiss()"></button>
</div>
<div class="modal-body" [class.warning]="warning">
    <div [innerHTML]="message"></div>

    @if (checkboxLabel !== '') {
        <div class="form-check mt-3">
            <input
                type="checkbox"
                class="form-check-input"
                id="confirmation-dialog-checkbox"
                [checked]="checked"
                (change)="toggleChecked()" />
            <label class="form-check-label" for="confirmation-dialog-checkbox">
                {{ checkboxLabel }}
            </label>
        </div>
    }
</div>

<div class="modal-footer" [class.warning]="warning">
    @if (showCancel) {
        <button type="button" class="btn" [class]="cancelButtonClass" (click)="decline()">
            {{ btnCancelText }}
        </button>
    }
    <button
        type="button"
        class="btn btn-primary"
        [disabled]="checkboxLabel !== '' && !checked"
        (click)="accept()">
        {{ btnOkText }}
    </button>
</div>
